module.exports = __webpack_public_path__ + "img/StMUV.c48ebdc8.jpg";